export default "__VITE_ASSET__GcFcSck2__"